import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import React from 'react';
import { cn } from '../../../utils/cn';

const ItemInfo = ({ title, text, handler, className }) => {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <p className={'text-xs'}>{title}</p>
      <div className={'flex justify-between items-center gap-2'}>
        <p className={'text-lg'}>{text}</p>
        {handler && (
          <button onClick={handler}>
            <ContentPasteIcon className={'text-gray-400 hover:text-orange-500'} />
          </button>
        )}
      </div>
    </div>
  );
};

export default ItemInfo;
